module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSelect),
      expression: "showSelect"
    }],
    staticClass: "upload_toutu_type"
  }, [_c('div', {
    staticClass: "select_type"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "upload_type"
  }, [_c('li', {
    staticClass: "type_item"
  }, [_c('div', {
    staticClass: "type_img my_img"
  }, [_c('input', {
    ref: "inputer",
    staticClass: "upload-btn",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleFileChange
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//img.58cdn.com.cn/m58/img/my_img.png"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("我的照片")])]), _vm._v(" "), _c('li', {
    staticClass: "type_item"
  }, [_c('div', {
    staticClass: "type_img virtual_img",
    on: {
      "click": _vm.showVirtualBox
    }
  }, [_c('img', {
    attrs: {
      "src": "//img.58cdn.com.cn/m58/img/virtual_img.png"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("默认头像")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user58pic !== ''),
      expression: "user58pic !== ''"
    }],
    staticClass: "type_item"
  }, [_c('div', {
    staticClass: "type_img",
    on: {
      "click": _vm.selectUserPic
    }
  }, [_c('img', {
    staticClass: "third-img",
    attrs: {
      "src": _vm.user58pic
    }
  })]), _vm._v(" "), _c('p', [_vm._v("58头像")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cancel",
    on: {
      "click": _vm.hidePop
    }
  }, [_c('span', [_vm._v("取消")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showSelect && _vm.showVirtual),
      expression: "!showSelect && showVirtual"
    }],
    staticClass: "virtual"
  }, [_c('div', {
    staticClass: "virtual_toutu"
  }, [_c('ul', {
    staticClass: "virtual_toutuList"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "virtual_item",
      class: {
        selected: index === _vm.selectedItem
      },
      on: {
        "click": function($event) {
          return _vm.chooseVirtual(item, index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "cancel",
    on: {
      "click": _vm.backSelect
    }
  }, [_c('span', [_vm._v("返回")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload_title"
  }, [_c('p', [_vm._v("选个上传的方式")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-584b72f9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/basic/headPortrait/selectBox.vue
// module id = 353
// module chunks = 0